/**
 * Feel free to use this file if you need javascript that is only
 * supposed to load on the front-end with your block.
 *
 * For instance, this can be handy if you want to add some interaction or slider
 * functionality not appropriate for the editor experience.
 */

const multiAccordions = document.querySelectorAll( '.wp-block-qala-blocks-multi-image-accordions' );

multiAccordions.forEach( multiAccordion => {
	const accordions = multiAccordion.querySelectorAll( '.wp-block-qala-blocks-single-accordion' );
	const accordionImageWrapper = multiAccordion.querySelector( '.multi-image-accordions__image-wrap' );
	accordions.forEach( accordion => {
		const togglePanel = accordion.querySelector( '.wp-block-qala-blocks-single-accordion__heading' );
		togglePanel.addEventListener( 'click', function() {
			const siblings = accordionImageWrapper.querySelectorAll( 'img' );
			if ( ! accordion.classList.contains( 'active' ) ) {
				accordion.classList.toggle( 'active' );
				const accordionImageId = accordion.dataset.accordionImageId;
				if ( accordionImageId !== '' ) {
					const accordionImage = accordionImageWrapper.querySelector( `[data-image-id="${ accordionImageId }"]` );
					siblings.forEach( sibling => {
						if ( sibling !== accordionImage && ! sibling.classList.contains( 'multi-accordion-image-hidden' ) ) {
							sibling.classList.add( 'multi-accordion-image-hidden' );
						}
					} );
					accordionImage.classList.remove( 'multi-accordion-image-hidden' );
				} else {
					siblings.forEach( sibling => {
						if ( ! sibling.classList.contains( 'multi-accordion-image-hidden' ) ) {
							sibling.classList.add( 'multi-accordion-image-hidden' );
						}
					} );
					accordionImageWrapper.querySelector( '[data-accordion-image-type="default"]' ).classList.remove( 'multi-accordion-image-hidden' );
				}
				accordionImageWrapper.animate( [
					// keyframes
					{ opacity: '0.5' },
					{ opacity: '1' },
				], {
					// timing options
					duration: 300,
				} );
				accordions.forEach( otherAccordion => {
					const panel = otherAccordion.querySelector( '.wp-block-qala-blocks-single-accordion__content' );
					otherAccordion.classList.remove( 'active' );
					panel.style.maxHeight = null;
				} );
			} else {
				siblings.forEach( sibling => {
					if ( ! sibling.classList.contains( 'multi-accordion-image-hidden' ) ) {
						sibling.classList.add( 'multi-accordion-image-hidden' );
					}
				} );
				accordionImageWrapper.querySelector( '[data-accordion-image-type="default"]' ).classList.remove( 'multi-accordion-image-hidden' );
			}
		} );
	} );
} );
